import { forwardRef } from 'react'
import { PlatformDevice } from '@/models/platformDevice'
import PlatformDeviceTableHeader, { SortColumn, SortDirection } from './PlatformDeviceTableHeader'
import PlatformDeviceTableRow from './PlatformDeviceTableRow'

interface PlatformDeviceTableProps {
  devices: PlatformDevice[],
  columnWidths: number[]
  sortColumn: SortColumn
  sortDirection: SortDirection
  onSort: (column: keyof PlatformDevice) => void
  onResizeStart: (e: React.MouseEvent, index: number) => void
}

const PlatformDeviceTable = forwardRef<HTMLTableElement, PlatformDeviceTableProps>(
  function PlatformDevice({
    devices,
    columnWidths,
    sortColumn,
    sortDirection,
    onSort,
    onResizeStart
  }, ref) {

    if (devices.length === 0) {
      return (
        <div className="no-devices">
          No devices match the current filters.
        </div>
      )
    }

    return (
      <div className="platform-device-table-container">
        <table className="platform-device-table" ref={ref}>
          <PlatformDeviceTableHeader
            columnWidths={columnWidths}
            sortColumn={sortColumn}
            sortDirection={sortDirection}
            onSort={onSort}
            onResizeStart={onResizeStart}
          />
          <tbody>
            {devices.map((device) => (
              <PlatformDeviceTableRow
                key={device.id}
                device={device}
              />
            ))}
          </tbody>
        </table>
      </div>
    )
  }
)

export default PlatformDeviceTable
export type { SortColumn, SortDirection }